import React, { useState, useEffect, useRef } from 'react';
import N3rveLogo from './../../images/N3rveLogo.png'
import './SignUp.css'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios';
import validator from 'validator'
import Cookies from 'universal-cookie';
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import { useJwt, decodeToken } from "react-jwt";
import { logtoWix } from '../Helpers/LogToWix';

function SignUp() {
  const [name, onChangeName] = useState('')
  const [email, onChangeEmail] = useState('')
  const [password, onChangePassword] = useState('');
  const [password2, onChangePassword2] = useState('');
  const [emailEmptyError, setEmailEmptyError] = useState(false)
  const [emailExistsError, setEmailExistsError] = useState(false)
  const [emailInvalidError, setEmailInvalidError] = useState(false)
  const [inactivebtn, setInactiveBtn] = useState(false)

  const [passwordSyntaxError, setPasswordSyntaxError] = useState(false)
  const [passwordEmptyError, setPasswordEmptyError] = useState(false)
  const [confirmError, setConfirmPasswordError] = useState(false)
  const [passwordMismatchError, setPasswordMismatchError] = useState(false)
  const cookies = new Cookies(null, { path: '/' });
  const { t, i18n } = useTranslation();

  const hasLogged = useRef(false);


  const navigate = useNavigate();

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  })

  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  const validate = (value) => {
    if (validator.isStrongPassword(value, {
      minLength: 8, minLowercase: 1,
      minUppercase: 1, minNumbers: 1, minSymbols: 1
    })) {
      setPasswordSyntaxError(false)
    } else {
      setPasswordSyntaxError(true)
    }
  }

  const handleResize = () => {
    // console.log(window.innerWidth)
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }


  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
    topFunction()

    if (!hasLogged.current) {
      if (cookies.get('token') !== undefined) {
        if (decodeToken(cookies.get('token')) !== null) {
          logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Signup Page", { "desc": "User opened the signup page" })
          hasLogged.current = true;
        } else {
          logtoWix("anonymous user", "pageview", "Signup Page", { "desc": "User opened the signup page" })
          hasLogged.current = true;
        }
      } else {
        logtoWix("anonymous user", "pageview", "Signup Page", { "desc": "User opened the signup page" })
        hasLogged.current = true;
      }
    }

  }, [])

  const handleSubmit = () => {
    let emailRegex = /[a-z0-9]+@[a-z0-9]+\.[a-z]{2,3}/;

    if (email.length === 0) {
      setEmailEmptyError(true)
    } else {
      setEmailEmptyError(false)
      if (!emailRegex.test(email)) {
        // invalid email
        setEmailInvalidError(true)
      } else {
        // valid email
        setEmailInvalidError(false)
      }
    }
    if (password.length === 0) {
      setPasswordEmptyError(true)
    } else {
      setPasswordEmptyError(false)
    }
    if (password2.length === 0) {
      setConfirmPasswordError(true)
    } else {
      setConfirmPasswordError(false)
    }

    if (password !== password2 && password2.length !== 0) {
      setPasswordMismatchError(true)
    } else {
      setPasswordMismatchError(false)
    }

    if (!emailEmptyError && !passwordEmptyError && !confirmError && !passwordMismatchError) {
      HandleSignUp()
    }

  }

  const HandleSignUp = () => {
    axios.post("https://n3rve.fly.dev/auth/signup", {
      "email": email,
      "password": password,
      "confirmPassword": password2,
      "domain": 'http://localhost:3000'
      // "domain":'https://n3rve-b4b3b625d069.herokuapp.com'
    }).
      then((response) => {

        if (response.status === 200) {
          cookies.set('email', email);

          logtoWix(email, "auth", "Signup Page", { "desc": "User directed to verify email" })

          navigate("/verify/email", { state: { email: email, password: password, password2: password2 } })
          setInactiveBtn(false)
        }

      }).catch(function (e) {
        console.log(e.response.data)
        logtoWix(email, "auth", "Signup Page", { "desc": "Unsuccessful signup" })
        if (e.response !== undefined) {
          if (e.response.data == "Email exists") {
            setEmailExistsError(true)
            setInactiveBtn(false)
            logtoWix(email, "auth", "Signup Page", { "desc": "Unsuccessful signup(Email Exists)" })
          }
        }
      });

  }

  return (

    <div style={{ width: '100vw' }}>

      {/* ******************************************** */}


      {/* DESKTOP VIEW */}

      {
        dimensions.width >= 1024 &&
        <div className="SignupContainer">

          <div className='SignupContainerLeft' >
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo' />
            </Link>

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '11.25em' }}>
              <div className='WelcomeBackTxt' style={{ marginBottom: '0.8em' }}>
                <Trans i18nKey="Letscreateyournerveacc" components={{ 1: <br /> }}
                >Let's create your <br /> N3RVE account
                </Trans></div>

              {/* <div className='SignupHeader'>Name</div>
                <input
                value={name}
                type="text"
                onChange={e => onChangeName(e.target.value)} 
                placeholder='Enter Name'
                className='SignupInput'
                /> */}

              <div className='SignupHeader'>{t('Email')}</div>

              {
                !emailEmptyError && !emailExistsError && !emailInvalidError &&
                <input
                  value={email}
                  tyle="email"
                  onChange={e => onChangeEmail(e.target.value)}
                  placeholder='Enter Email'
                  className='SignupInput'
                />
              }

              {
                (emailEmptyError || emailExistsError || emailInvalidError) &&
                <input
                  value={email}
                  tyle="email"
                  onChange={e => onChangeEmail(e.target.value)}
                  placeholder='Enter Email'
                  className='SignupInput'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }


              {
                emailEmptyError &&
                <div className='ErrorTxt'>Email cannot be empty</div>
              }

              {
                emailExistsError &&
                <div className='ErrorTxt'>Email already Exists. Login Instead.</div>
              }

              {
                emailInvalidError &&
                <div className='ErrorTxt'>Invalid Email</div>
              }


              <div className='SignupHeader'>{t('Password')}</div>

              {
                !passwordEmptyError && !passwordMismatchError &&
                <input
                  value={password}
                  onChange={e => { onChangePassword(e.target.value); validate(e.target.value) }}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                />
              }

              {
                (passwordEmptyError || passwordMismatchError) &&
                <input
                  value={password}
                  onChange={e => { onChangePassword(e.target.value); validate(e.target.value) }}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }

              {
                passwordSyntaxError &&
                <div className='ErrorTxt'>Password must have a have length of 8<br />1 Lowercase e.g (a-z)<br />1 Uppercase e.g (A-Z)<br />1 Number e.g (0-9)<br />1 symbol e.g (!-#$%&)</div>
              }

              {
                passwordEmptyError &&
                <div className='ErrorTxt'>Password cannot be empty</div>
              }

              <div className='SignupHeader'>{t('Confirmpassword')}</div>

              {
                !confirmError && !passwordMismatchError &&
                <input
                  value={password2}
                  onChange={e => onChangePassword2(e.target.value)}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                />
              }

              {
                (confirmError || passwordMismatchError) &&
                <input
                  value={password2}
                  onChange={e => onChangePassword2(e.target.value)}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }


              {
                confirmError &&
                <div className='ErrorTxt'>Confirm Password cannot be empty</div>
              }

              {
                passwordMismatchError &&
                <div className='ErrorTxt'>Passwords do not match</div>
              }

              <span className='signupdisclaimer'> <Trans i18nKey="Bycreatinganacc"
              >By creating an account you agree to the <span style={{ textDecoration: 'underline' }}>terms of service</span> and privacy policy.
              </Trans></span>
              {
                !inactivebtn &&
                <div className='SignupBtn' style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={() => { setInactiveBtn(true); handleSubmit() }}>{t('Submit')}<div className="HoverOverlay" /></div>
              }

              {
                inactivebtn &&
                <div className='SignupBtn' style={{ textDecoration: 'none' }}>{t('Submit')}<div className="HoverOverlay" /></div>
              }

              <span className='HaveAccTxt'>{t('Alreadyhaveacc')} <Link to="/Login"><span className='HaveAccTxt' style={{ textDecoration: 'underline', marginBottom: '6.9em' }}>{t('Logintxt')}</span></Link></span>
            </div>

          </div>

          <div className='SignupContainerRight' style={{ backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/eyufx2dvaxabuykbx9sl")`, height: '100vh', width: '50%' }} />

        </div>

      }

      {/* ******************************************** */}


      {/*TABLET VIEW */}

      {
        dimensions.width >= 768 && dimensions.width < 1024 &&
        <div className="SignupContainer" style={{ justifyContent: 'space-between' }}>

          <div className='SignupContainerLeft' >
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo' />
            </Link>

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '2.25em' }}>
              <div className='WelcomeBackTxt' style={{ marginBottom: '0.8em' }}>
                <Trans i18nKey="Letscreateyournerveacc" components={{ 1: <br /> }}
                >Let's create your <br /> N3RVE account
                </Trans></div>

              {/* <div className='SignupHeader'>Name</div>
                <input
                value={name}
                type="text"
                onChange={e => onChangeName(e.target.value)} 
                placeholder='Enter Name'
                className='SignupInput'
                /> */}

              <div className='SignupHeader'>{t('Email')}</div>

              {
                !emailEmptyError && !emailExistsError && !emailInvalidError &&
                <input
                  value={email}
                  tyle="email"
                  onChange={e => onChangeEmail(e.target.value)}
                  placeholder='Enter Email'
                  className='SignupInput'
                />
              }

              {
                (emailEmptyError || emailExistsError || emailInvalidError) &&
                <input
                  value={email}
                  tyle="email"
                  onChange={e => onChangeEmail(e.target.value)}
                  placeholder='Enter Email'
                  className='SignupInput'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }


              {
                emailEmptyError &&
                <div className='ErrorTxt'>Email cannot be empty</div>
              }

              {
                emailExistsError &&
                <div className='ErrorTxt'>Email already Exists. Login Instead.</div>
              }

              {
                emailInvalidError &&
                <div className='ErrorTxt'>Invalid Email</div>
              }


              <div className='SignupHeader'>{t('Password')}</div>

              {
                !passwordEmptyError && !passwordMismatchError &&
                <input
                  value={password}
                  onChange={e => { onChangePassword(e.target.value); validate(e.target.value) }}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                />
              }

              {
                (passwordEmptyError || passwordMismatchError) &&
                <input
                  value={password}
                  onChange={e => { onChangePassword(e.target.value); validate(e.target.value) }}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }

              {
                passwordSyntaxError &&
                <div className='ErrorTxt'>Password must have a have length of 8<br />1 Lowercase e.g (a-z)<br />1 Uppercase e.g (A-Z)<br />1 Number e.g (0-9)<br />1 symbol e.g (!-#$%&)</div>
              }

              {
                passwordEmptyError &&
                <div className='ErrorTxt'>Password cannot be empty</div>
              }

              <div className='SignupHeader'>{t('Confirmpassword')}</div>

              {
                !confirmError && !passwordMismatchError &&
                <input
                  value={password2}
                  onChange={e => onChangePassword2(e.target.value)}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                />
              }

              {
                (confirmError || passwordMismatchError) &&
                <input
                  value={password2}
                  onChange={e => onChangePassword2(e.target.value)}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }


              {
                confirmError &&
                <div className='ErrorTxt'>Confirm Password cannot be empty</div>
              }

              {
                passwordMismatchError &&
                <div className='ErrorTxt'>Passwords do not match</div>
              }

              <span className='signupdisclaimer'> <Trans i18nKey="Bycreatinganacc"
              >By creating an account you agree to the <span style={{ textDecoration: 'underline' }}>terms of service</span> and privacy policy.
              </Trans></span>
              {
                !inactivebtn &&
                <div className='SignupBtn' style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={() => { setInactiveBtn(true); handleSubmit() }}>{t('Submit')}</div>
              }
              {
                inactivebtn &&
                <div className='SignupBtn' style={{ textDecoration: 'none' }}>{t('Submit')}</div>
              }
              <span className='HaveAccTxt'>{t('Alreadyhaveacc')} <Link to="/Login"><span className='HaveAccTxt' style={{ textDecoration: 'underline', marginBottom: '6.9em' }}>{t('Logintxt')}</span></Link></span>
            </div>

          </div>

          <div className='SignupContainerRight' style={{ backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/eyufx2dvaxabuykbx9sl")`, width: '30%' }} />

        </div>

      }

      {/* ******************************************** */}


      {/*MOBILE VIEW */}

      {
        dimensions.width < 768 &&
        <div className="SignupContainer" style={{ height: '100vh', overflowY: 'scroll' }}>

          <div className='SignupContainerLeft' style={{ width: '95%' }} >
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo' />
            </Link>

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '2.25em', width: '85%' }}>
              <div className='WelcomeBackTxt' style={{ marginBottom: '0.8em', width: '95%' }}>
                <Trans i18nKey="Letscreateyournerveacc" components={{ 1: <br /> }}
                >Let's create your <br /> N3RVE account
                </Trans></div>

              {/* <div className='SignupHeader'>Name</div>
                <input
                value={name}
                type="text"
                onChange={e => onChangeName(e.target.value)} 
                placeholder='Enter Name'
                className='SignupInput'
                /> */}

              <div className='SignupHeader'>{t('Email')}</div>

              {
                !emailEmptyError && !emailExistsError && !emailInvalidError &&
                <input
                  value={email}
                  tyle="email"
                  onChange={e => onChangeEmail(e.target.value)}
                  placeholder='Enter Email'
                  className='SignupInput'
                />
              }

              {
                (emailEmptyError || emailExistsError || emailInvalidError) &&
                <input
                  value={email}
                  tyle="email"
                  onChange={e => onChangeEmail(e.target.value)}
                  placeholder='Enter Email'
                  className='SignupInput'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }


              {
                emailEmptyError &&
                <div className='ErrorTxt'>Email cannot be empty</div>
              }

              {
                emailExistsError &&
                <div className='ErrorTxt'>Email already Exists. Login Instead.</div>
              }

              {
                emailInvalidError &&
                <div className='ErrorTxt'>Invalid Email</div>
              }


              <div className='SignupHeader'>{t('Password')}</div>

              {
                !passwordEmptyError && !passwordMismatchError &&
                <input
                  value={password}
                  onChange={e => { onChangePassword(e.target.value); validate(e.target.value) }}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                />
              }

              {
                (passwordEmptyError || passwordMismatchError) &&
                <input
                  value={password}
                  onChange={e => { onChangePassword(e.target.value); validate(e.target.value) }}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }

              {
                passwordSyntaxError &&
                <div className='ErrorTxt'>Password must have a have length of 8<br />1 Lowercase e.g (a-z)<br />1 Uppercase e.g (A-Z)<br />1 Number e.g (0-9)<br />1 symbol e.g (!-#$%&)</div>
              }

              {
                passwordEmptyError &&
                <div className='ErrorTxt'>Password cannot be empty</div>
              }

              <div className='SignupHeader'>{t('Confirmpassword')}</div>

              {
                !confirmError && !passwordMismatchError &&
                <input
                  value={password2}
                  onChange={e => onChangePassword2(e.target.value)}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                />
              }

              {
                (confirmError || passwordMismatchError) &&
                <input
                  value={password2}
                  onChange={e => onChangePassword2(e.target.value)}
                  placeholder='Enter Password'
                  className='SignupInput'
                  type='password'
                  style={{ border: '1px #FF6363 solid' }}
                />
              }


              {
                confirmError &&
                <div className='ErrorTxt'>Confirm Password cannot be empty</div>
              }

              {
                passwordMismatchError &&
                <div className='ErrorTxt'>Passwords do not match</div>
              }

              <span className='signupdisclaimer'> <Trans i18nKey="Bycreatinganacc"
              >By creating an account you agree to the <span style={{ textDecoration: 'underline' }}>terms of service</span> and privacy policy.
              </Trans></span>
              {
                !inactivebtn &&
                <div className='SignupBtn' style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={() => { setInactiveBtn(true); handleSubmit() }}>{t('Submit')}</div>
              }

              {
                inactivebtn &&
                <div className='SignupBtn' style={{ textDecoration: 'none' }}>{t('Submit')}</div>
              }
              <span className='HaveAccTxt'>{t('Alreadyhaveacc')} <Link to="/Login"><span className='HaveAccTxt' style={{ textDecoration: 'underline', marginBottom: '6.9em' }}>{t('Logintxt')}</span></Link></span>
            </div>

          </div>


        </div>

      }


    </div>

  );
}

export default SignUp;
